import { getGlobalHeadersAsObject } from "../global-headers";

export const getTagsForObject = (
	objectName: string,
	objectId: number
): Promise<string[]> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getTagPerson called with invalid argument id '${objectId}'. Expected number`
		);
	}
	return fetch(`/api/v2/${objectName}/${objectId}/tags/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const getTags = (): Promise<string[]> => {
	return fetch(`/api/v2/tags/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const updateTags = (
	objectName: string,
	objectId: number,
	tags: string[],
	skipAudit: boolean = false
): Promise<string[]> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getPersonExperienceById called with invalid argument id '${objectId}'. Expected number`
		);
	}
	return fetch(`/api/v2/${objectName}/${objectId}/tags/`, {
		method: "POST",
		body: JSON.stringify({
			tags: tags,
			skip_audit: skipAudit,
		}),
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
	}).then((res) => res.json());
};
